<template>
  <wizard v-if="shouldBeVisible" class="onboarding" :steps="wizardSteps" fullscreenOnMobile @close="finishOnboarding" />
</template>

<script>
import store from 'store'
import { mapState, mapGetters } from 'vuex'

export default {
  name: 'onboarding',
  computed: {
    ...mapState({ isWebView: state => state.window.isWebView }),
    ...mapGetters({ isMobile: 'device/isMobile' }),
    shouldBeVisible() {
      return store.get('onboarding_finished') === false && !this.isWebView
    },
    wizardSteps() {
      return [{
        image: {
          sources: [{
            media: '(min-width: 500px)',
            srcset: require('@/assets/onboarding/step1-desktop.jpg')
          }],
          default: require('@/assets/onboarding/step1-mobile.jpg')
        },
        title: 'Olá, que bom ter você no PlayKids!',
        text: `Aqui você encontra <b>todos os nossos vídeos</b> com seus personagens favoritos. :)<br/>Para acessar <b>jogos e livros</b>, use sua conta ${this.isMobile ? 'em <a href="https://playkidsapp.page.link/playphone" target="_blank" rel="noopener">nosso aplicativo</a> para smartphones' : 'no PlayKids App em seu smartphone'}.`
      }, {
        image: {
          sources: [{
            media: '(min-width: 500px)',
            srcset: require('@/assets/onboarding/step2-desktop.jpg')
          }],
          default: require('@/assets/onboarding/step2-mobile.jpg')
        },
        title: 'Assista a conteúdos exclusivos',
        text: 'Preparamos todos os meses <b>curadorias especiais</b> sobre vários assuntos diferentes e também produzimos <b>conteúdos originais</b> que você só encontra aqui!'
      }, {
        image: {
          sources: [{
            media: '(min-width: 500px)',
            srcset: require('@/assets/onboarding/step3-desktop.jpg')
          }],
          default: require('@/assets/onboarding/step3-mobile.jpg')
        },
        title: 'Classificação indicativa',
        text: 'Todo o nosso conteúdo possui <b>classificação indicativa Livre</b>. A idade aqui é apenas o momento em que os pequenos normalmente desenvolvem o que o desenho ensina.'
      }, {
        image: {
          sources: [{
            media: '(min-width: 500px)',
            srcset: require('@/assets/onboarding/step4-desktop.jpg')
          }],
          default: require('@/assets/onboarding/step4-mobile.jpg')
        },
        title: 'Eixos de desenvolvimento',
        text: 'Todo o nosso conteúdo é selecionado pensando para ajudar no desenvolvimento. Aqui você acompanha o que cada show apresenta.'
      }]
    }
  },
  methods: {
    finishOnboarding() {
      store.set('onboarding_finished', true)
    }
  }
}
</script>
